module.exports = __webpack_public_path__ + "img/logo1.cca4ce75.png";